export default [
  {
    path: '/customer-display/invoice',
    name: 'customer-display-invoice',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer-display/invoice.vue')
  }
]
